package nl.astraeus.wiki.service

import nl.astraeus.wiki.domain.User

object UserService {
  val loggedIn: Boolean
    get() {
      return currentUser != null
    }
  var currentUser: User? = null
    set(value) {
      console.log("Setting user to $value")
      field = value
    }

}
